import { hasS3Object } from "@/lib/aws-amplify/storage";

import { convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour } from "@/components/features/_shared/validation-schema/converter";

import { DUMMY_IMAGE } from "@/constants/dummy-image";

import type { ProductOptionFormModel } from "../../../../../type";
import type { ServerModel } from "../../type";


export const serverModelToInputModelConverter = (serverModel: ServerModel): ProductOptionFormModel["InputModel"] => {
	const { optionNewItem, hotelPolicy } = serverModel;

	// 他のアイテムが初期値になりうるプロパティ
	const requiredPrepMillisecond: number =
		optionNewItem.requiredPrepMillisecond || hotelPolicy?.requiredPrepMillisecond || 0;
	const cancelPolicy = optionNewItem.cancelPolicy ?? [];

	const { requiredPrepMillisecondBeforeDate, requiredPrepMillisecondBeforeHour } =
		convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour(requiredPrepMillisecond);

	const inputModel: ProductOptionFormModel["InputModel"] = {
		hotelID: optionNewItem.hotelID,
		optionID: optionNewItem.optionID,

		name: optionNewItem.name,

		optionType: optionNewItem.optionType,

		availablePlanIDs: optionNewItem.availablePlanIDs,

		billingTypeTarget: optionNewItem.billingTypeTarget,
		billingTypeTerm: optionNewItem.billingTypeTerm,
		description: optionNewItem.description,
		inSale: optionNewItem.inSale,
		isNextMorning: optionNewItem.isNextMorning,
		isNotDiscountTarget: optionNewItem.isNotDiscountTarget ?? false,
		keyVisuals: optionNewItem.keyVisuals,
		mainKeyVisual: hasS3Object(optionNewItem.mainKeyVisual) ? optionNewItem.mainKeyVisual : DUMMY_IMAGE.s3Object,

		maxBuyableNumPerTarget: optionNewItem.maxBuyableNumPerTarget ?? 0,
		maxDailyStockNum: optionNewItem.maxDailyStockNum ?? undefined,
		maxStockNum: optionNewItem.maxStockNum,
		minimumBuyableNumPerTarget: optionNewItem.minimumBuyableNumPerTarget ?? undefined,

		price: optionNewItem.price,

		saleEnd: optionNewItem.saleEnd,
		saleStart: optionNewItem.saleStart,
		saleStartBeforeDate: optionNewItem.saleStartBeforeDate,
		saleTypeForPlan: optionNewItem.saleTypeForPlan,
		saleTypeForTerm: optionNewItem.saleTypeForTerm,

		stayableDayOfTheWeek: optionNewItem.stayableDayOfTheWeek,
		isHolidayStayable: optionNewItem.isHolidayStayable,
		stayableEnd: optionNewItem.stayableEnd,
		stayableStart: optionNewItem.stayableStart,

		subOptions: optionNewItem.subOptions,
		useAsSubOption: optionNewItem.useAsSubOption,
		multiSubOptionSelectable: optionNewItem.multiSubOptionSelectable,
		isDateTabbedTimeSelectionEnabled: optionNewItem.isDateTabbedTimeSelectionEnabled,

		// 他のアイテムが初期値になりうるプロパティ
		requiredPrepMillisecond,
		cancelPolicy,

		// InputModel 固有のプロパティ
		requiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeHour,
	} satisfies ProductOptionFormModel["InputModel"];

	return inputModel;
};
